import { render } from "./EventAttendeeCard.vue?vue&type=template&id=18b0cbf4&scoped=true"
import script from "./EventAttendeeCard.vue?vue&type=script&lang=ts"
export * from "./EventAttendeeCard.vue?vue&type=script&lang=ts"

import "./EventAttendeeCard.vue?vue&type=style&index=0&id=18b0cbf4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18b0cbf4"

export default script